/** 网站底部 ICP / 公安联网备案（单一数据源，供 SiteBeianLinks 复用） */

export const SITE_ICP = {
  label: '沪ICP备2025152935号',
  href: 'https://beian.miit.gov.cn/#/Integrated/recordQuery',
} as const;

export const SITE_MPS = {
  label: '沪公网安备31010702010193号',
  href: 'https://beian.mps.gov.cn/#/query/webSearch?code=31010702010193',
  iconSrc: '/home/beian-mps.png',
} as const;
